var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2435 27.1407C54.5571 28.7984 57.242 31.4884 58.8935 34.8051C63.1466 43.0244 60.4356 53.1306 52.6398 58.1179C44.844 63.1051 34.5322 61.3301 28.8526 54.0233C24.6153 48.4904 23.9294 41.0168 27.0889 34.8051C28.7441 31.4861 31.4343 28.7959 34.7533 27.1407C35.312 26.8653 35.9736 26.8998 36.5007 27.2317C37.0278 27.5636 37.3448 28.1454 37.3379 28.7682V43H48.6731V28.7682C48.6687 28.1494 48.9838 27.5722 49.5066 27.2411C50.0294 26.9101 50.686 26.8721 51.2435 27.1407Z",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9978,
    cy: 43,
    r: 32.2634,
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0346 58.5044V73.998",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9604 58.5079V73.998",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/Resource.20b519b850b82980c8f59c3cc42dc654.svg";
export { ForwardRef as ReactComponent };